import React from "react";
import { Icon, IconProps as ChakraIconProps } from "@chakra-ui/react";

const LooksRare = ({ ...rest }: ChakraIconProps) => {
  return (
    <Icon viewBox={"0 0 148 148"} fill={"none"} {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74 86C61.3026 86 51 75.7077 51 63C51 50.2923 61.3026 40 74 40C86.6974 40 97 50.2923 97 63C97 75.7077 86.6974 86 74 86ZM64 63C64 68.5251 68.4794 73 74 73C79.5206 73 84 68.5251 84 63C84 57.4749 79.5206 53 74 53C68.4794 53 64 57.4749 64 63Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 63.0304L44 19H104L148 63.0304L74 137L0 63.0304ZM108 46.9998C89.3047 28.2224 58.6953 28.2225 40 46.9999L24 63.0001L40 79.0002C58.6953 97.7776 89.3047 97.7775 108 79.0001L124 63.0001L108 46.9998Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default LooksRare;
